import React from 'react'

class Home extends React.Component {
  render(){
    return(
      <div>
        <h3>Sota Iwahashi</h3>
        <h4>サポートページ</h4>
        
      </div>
    )
  }
}


export default Home;